// extracted by mini-css-extract-plugin
var _1 = "AiCopilotChatPanel-module__animateUploadProgressBarWidth--Vbo3i";
var _2 = "AiCopilotChatPanel-module__animatedBackground--cFcRS";
var _3 = "AiCopilotChatPanel-module__badge--kQmNi";
var _4 = "AiCopilotChatPanel-module__container--EPG6e";
var _5 = "AiCopilotChatPanel-module__dots--socBt";
var _6 = "AiCopilotChatPanel-module__footer--Kg_aj";
var _7 = "AiCopilotChatPanel-module__hasMessages--PXZmC";
var _8 = "AiCopilotChatPanel-module__isEditing--WHGq4";
var _9 = "AiCopilotChatPanel-module__isOpen--W0snd";
var _a = "AiCopilotChatPanel-module__loadingIndicator--uosd0";
var _b = "AiCopilotChatPanel-module__menuItem--W4RYg";
var _c = "AiCopilotChatPanel-module__message--MVTHr";
var _d = "AiCopilotChatPanel-module__messageExchange--v0eaC";
var _e = "AiCopilotChatPanel-module__messagesContainer--b_8ne";
var _f = "AiCopilotChatPanel-module__overflowMenuButton--GWwxO";
var _10 = "AiCopilotChatPanel-module__overflowMenuContainer--N7IVD";
var _11 = "AiCopilotChatPanel-module__overflowMenuFloating--mVBrk";
var _12 = "40px";
var _13 = "AiCopilotChatPanel-module__postPills--xmuDm";
var _14 = "AiCopilotChatPanel-module__scrollToBottomButton--KoApr";
var _15 = "AiCopilotChatPanel-module__scrollToBottomButtonContainer--W1OmY";
var _16 = "AiCopilotChatPanel-module__submenuItem--t7DEG";
var _17 = "AiCopilotChatPanel-module__system--OtyXk";
var _18 = "AiCopilotChatPanel-module__user--mX7yA";
var _19 = "AiCopilotChatPanel-module__userMessageContent--at98D";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "badge", _4 as "container", _5 as "dots", _6 as "footer", _7 as "hasMessages", _8 as "isEditing", _9 as "isOpen", _a as "loadingIndicator", _b as "menuItem", _c as "message", _d as "messageExchange", _e as "messagesContainer", _f as "overflowMenuButton", _10 as "overflowMenuContainer", _11 as "overflowMenuFloating", _12 as "paddingBottom", _13 as "postPills", _14 as "scrollToBottomButton", _15 as "scrollToBottomButtonContainer", _16 as "submenuItem", _17 as "system", _18 as "user", _19 as "userMessageContent" }
